<template>
    <div ref="imageBox" class="image-box">
        <img v-show="!isLoading" ref="resourceImg" :src="src" :style="styleString" :class="className" alt="image resource" class="img-resource">
        <img v-show="isLoading" ref="loadingImage" :src="loadingSrc" class="loading">
    </div>
</template>

<script>
import loading from '@/assets/image/loading.png';
import tool from '@/assets/scripts/tool';

export default {
    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        
        currentShow: {
            type: String,
            default: ''
        },

        hwFilesData: {
            type: Object,
            default: null
        }
    },

    data: function() {
        return {
            componentId: null,
            loadingSrc: loading,
            src: null,
            styleString: null,
            className: null,
            imageId: null,
            supportedEventNames: ['resource.show', 'files.zoom','common.moveJoystick', 'files.rotate'],
            baseFactor: 1.0, // the fit-to-screen factor
            isLoading: true,
            srcShow: null,
            moveX: 0,
            moveY: 0,
            newFactor: 0,
            newRotate: 0,
        };
    },

    computed:{

    },
    watch: {
        currentShow: function(newVal, oldVal) {
            if (newVal != this.componentId && oldVal == this.componentId) {
                this.layoutLoading();
                this.isLoading = true;
                this.moveX = 0;
                this.moveY = 0;
            }
        },

        hwFilesData: function(newVal) {
            if (this.isLock) return;
            if (this.isLock && this.componentId === 'hw-img') return;
            let data = newVal.data;
            data.id = newVal.data.relationId;
            console.log(data)
            this.$nextTick(() => {
                this.showData(data);
            });
            
        }
    },

    created: function() {
        if (this.isLock) return;
        if (!this.hwFilesData) return;
        if (this.isLock && this.componentId === 'hw-img') return;
        let data = this.hwFilesData.data;
        data.id = this.hwFilesData.data.relationId;
        console.log(data);
        this.$nextTick(() => {
            this.showData(data);
        });
            
        
    },
    
    mounted: function () {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
        this.layoutUI();
    },

    /**
     * In developing and debugging phase, the vue object seems to be left in the browser js engine
     * it will handle the window message multiple times by mistake
     * remove the handlers when the vue object is destroyed
     */
    destroyed: function() {
        // console.log(this.componentId, ' is destroyed, and the event handlers are removed');
        window.removeEventListener('message', this.windowMessageHandler);
    },

    
    methods: {
        showData: function(data) {
            this.className = '';
            this.imageId = data.id;
            this.styleString = 'scale(0, 0)';
            this.newRotate = 0;
            this.isLoading = true;
            this.srcShow = data.url;
            const src = data.url;
            const tempImage = new Image();
            const me = this;
            
            tempImage.addEventListener('load', function() {
                if (me.srcShow !== src) return;
                const iw = tempImage.width;
                const ih = tempImage.height;
                const rect = me.$refs.imageBox.getBoundingClientRect();
                const cw = rect.width;
                const ch = rect.height;
                if (cw <= 0 || ch <= 0) {
                    console.error('the container of the image is too small');
                    return;
                }

                let factor = 1.0;
                if (iw > cw || ih > ch) {
                    factor = Math.max(iw / cw, ih / ch);
                }
                
                me.baseFactor = 1 / factor;

                const left = (cw - iw) / 2;
                const top = (ch - ih) / 2;
                
                me.$refs.resourceImg.style.left = left + 'px';
                me.$refs.resourceImg.style.top  = top  + 'px';
                me.$refs.resourceImg.style.width = iw + 'px';
                me.$refs.resourceImg.style.height = ih + 'px';

                me.isLoading = false;
                me.src = this.src;
                setTimeout(() => {
                    me.styleString = 'transform: scale(' + me.baseFactor + ', ' + me.baseFactor + ')';
                    me.newFactor = me.baseFactor;
                }, 50);
                
            });
            tempImage.src = src;
            this.layoutLoading();
        },
        
        /**
         * Zoom the image to the target factor.
         * the base factor if the initial factor when the image loaded and show on and fit to the screen 
         * @param {number} factor the target factor
         */
        zoomTo: function(factor) {

            // if (isNaN(factor)) return;
            if (factor.scaleFactor) {
                this.newFactor = this.baseFactor * factor.scaleFactor;
                this.newFactor = this.newFactor.toFixed(4);
            }
            
            this.styleString = 'transform: ' + tool.getImgStyle(this.newFactor, this.moveX, this.moveY, this.newRotate);
        },

        moveJoystick: function(data) {
            console.log(this.newFactor);
            console.log(data);
            let direction = data.direction;
            if (direction === 'LEFT') {
                this.moveX += 40;
            } else if (direction === 'RIGHT') {
                this.moveX -= 40;
            } else if (direction === 'UP') {
                this.moveY += 40;
            } else if (direction === 'DOWN') {
                this.moveY -= 40;
            } else {
                return;
            }
            this.styleString = 'transform: ' + tool.getImgStyle(this.newFactor, this.moveX, this.moveY, this.newRotate);
        },

        layoutUI: function() {
            this.layoutLoading();
        },

        /**
         * Layout the loading image
         * @returns {void}
         */
        layoutLoading: function() {
            const rect = this.$refs.imageBox.getBoundingClientRect();
            const loadingWidth = 100;
            const loadingHeight = 100;
            // this.$refs.loadingImage.style.animation = '';
            this.$refs.loadingImage.style.width = loadingWidth + 'px';
            this.$refs.loadingImage.style.height = loadingHeight + 'px';
            this.$refs.loadingImage.style.left = Math.round((rect.width - loadingWidth) / 2) + 'px';
            this.$refs.loadingImage.style.top = Math.round((rect.height - loadingHeight) / 2) + 'px';
        },

        rotate: function(msgData) {
            this.newRotate += 90;
            this.styleString = 'transform: ' + tool.getImgStyle(this.newFactor, this.moveX, this.moveY, this.newRotate);
        },

        windowMessageHandler: function(e) {
            let msg = e.data;
            if (! msg.eventName) return;
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;
            if (this.isLock && this.currentShow === this.componentId) return;
            // 如果我是隐藏的那个，那么没有必要加载图片资源，节省网络带宽
            if (this.currentShow !== this.componentId && this.currentShow !== 'hw-1') return;
            if (this.isLock && this.currentShow === this.componentId && this.currentShow === 'hw-1') return;
            // console.log(msg)

            let msgData = msg.data;
            if (!msgData) return;
            if (msg.eventName === 'resource.show') {
                if (! msgData.mimeType || !(msgData.mimeType.startsWith('image/'))) return;
                this.showData(msgData);
            } else if (msg.eventName === 'files.zoom') {
                console.log(msgData)
                this.zoomTo(msgData);
            } else if (msg.eventName === 'common.moveJoystick') {
                this.moveJoystick(msgData);
            } else if (msg.eventName === 'files.rotate') {
                this.rotate(msgData);
            } else {
                return;
            }
        }
    },
};
</script>

<style scoped>
    .image-box {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        overflow: auto;
    }

    .image-box .img-resource {
        position: absolute;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        transition-property: transform, -moz-transform, -webkit-transform;
        transition-duration: 400ms;
        transform: scale(0, 0);
    }

    .image-box .loading {
        position: absolute;
        animation: load 1s;
        animation-timing-function: linear;
        animation-direction: reverse;
        animation-iteration-count: infinite;
    }

    @keyframes load {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(-360deg);
        }
    }

</style>


